import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CampaignService } from 'src/app/_services/campaign.service';
import { EmailIntegrationService } from 'src/app/_services/email-integration.service';
import { LoadingService } from 'src/app/_services/loading.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';

@Component({
  selector: 'app-email-campaign-connect',
  templateUrl: './email-campaign-connect.component.html',
  styleUrls: ['./email-campaign-connect.component.scss']
})
export class EmailCampaignConnectComponent implements OnInit {
  gmailAccountDetails: any;
  outlookAccountDetails: any;
  loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
  displayPage = false;

  constructor(private router: Router, private emailintegrationservice: EmailIntegrationService, private emailCampaignService: CampaignService, private _localstorageservice: LocalStorageService) {
  }
  
  ngOnInit() {
    this.loadn[0].style.display = 'block';
    // this.router.navigate(['/email-campaign/dashboard']);
    this.fetchIntegration()
  }

  fetchIntegration(){
    this.emailintegrationservice.fetchintegratedemails().subscribe((res:any)=>{
     if(res.status == 'success'){
       if(res.integratedemailsarray && res.integratedemailsarray.length){
        this.gmailAccountDetails = res.integratedemailsarray.filter(x => x.integrationplatform == 'gmail')[0]
        this.outlookAccountDetails = res.integratedemailsarray.filter(x => x.integrationplatform == 'outlook')[0]
        this.getCampaigns({created_by: this._localstorageservice.getItem('userdata').userid});
        
       }else{
         this.gmailAccountDetails = null
         this.outlookAccountDetails = null
          this.loadn[0].style.display = 'none'
          this.displayPage = true;
       }
     }
    })
  }
  onGmailConnect(event: any) {
    // Handle the event emitted by the Gmail button
    if (event.success) {
      // Connection successful
      this.fetchIntegration();
      // Redirect to email-campaign-dashboard
      // this.router.navigate(['/email-campaign/dashboard']);
    } else {
      // Connection error
      console.error('Error connecting to Gmail:', event.error);
    }
  }
  onOutlookConnect(event: any) {
    // Handle the event emitted by the Gmail button
    if (event.success) {
      this.fetchIntegration();
      // Connection successful
      // Redirect to email-campaign-dashboard
    // this.router.navigate(['/email-campaign/dashboard']);
    } else {
      // Connection error
      console.error('Error connecting to outlook:', event.error);
    }
  }
  getCampaigns(data: {}) {
    // const tempData = this.campaigns;
    // this.displayCampaigns = tempData.slice(this.startIndex, this.endIndex);
    this.emailCampaignService.getCampaigns(data).subscribe(
      (data: any[]) => {
        if(data['total']){
          this.router.navigate(['/email-campaign/campaign-listing']);
        }
        else{
          this.router.navigate(['/email-campaign/dashboard']);
        }
        // this.totalCount = ???
          this.displayPage = true;
          this.loadn[0].style.display = 'none'
      },
      error => {
        console.error('Error getting campaigns:', error);
          this.displayPage = true;
          this.loadn[0].style.display = 'none'
        }
        
        );

  }

}
